import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import {
    Modal
} from '@shopify/polaris';
import './index.css'
import { reqClickAppNoticeCount, reqSetShowModalStatus, reqAddActionEventLog } from '../../../../../api';
import { store } from '../../../../../redux/store';
import {
} from '@shopify/polaris-icons';
import ImageShowDetail from "../../../../../components/ImageShowDetail";
import utils from "../../../../../utils/utils";
import { computeBestDiscount } from '../../../../../utils/planRateCalc';
import Language from '../../../../../i18n/Language';
import {
    buildActivityModalExposureData,
    getNextActivityModalExposureLatch,
    shouldReportActivityModalExposure,
} from './activityModalExposure';

const t = Language

class EventInformation extends Component {

    activityModalWasOpen = false;

    state = {
        loadingPage: true,
        appExpiredTime: '00:00:00',
        zjExpiredTime: '00:00:00',
        //是否显示公告信息
        showNotice: false,
        //显示公告页面index or pricing
        showType: this.props.showType ? this.props.showType : "",
        handleChange: false,
        //首页新用户弹窗
        showIndexModal: false,
        //数据
        couponData: {},
        appCouponData: this.props.couponData.app_coupon,
        zjCouponData: {},
        // 活动
        level: this.props.level,
        isFreeUser: this.props.level,
        showBlackFridayModal: this.props.showBlackFridayModal,
        showBlackFridayBanner: this.props.showBlackFridayBanner,
        isDashhome: window.location.pathname, // 页面路由
        blackOpenBanner: false, // banner打开状态
        activityMes: this.props.activityMes, // 活动信息
        isHasActivity: this.props.isHasActivity, // 活动状态
        actId: this.props.actId, // 活动id
        actName: this.props.actName, // 活动Name
        isFirstBlackModal: false,
        // 新手引导列表
        isShowGuideModal: true, // 新手引导状态
        imageDetailStatus: false, // 图片预览组件
        imageShowList: [], // 预览图片列表
        selImg: '', // 当前预览图片
        phoneNewbieList: [], // 移动端新手引导列表
        phoneNewbieSelected: 0,
        isShowGuideModalAnimate: false,
        isShowNewbieTipModal: false,
        newbieTipTop: 0,
        mealPlanList: [
            { label: 'All Plans', value: 0, sublabel: '' },
            { label: 'Forever Free', value: 1, sublabel: '' },
            { label: 'Pro Plan', value: 2, sublabel: 'per month' },
            { label: 'Pre Plan', value: 4, sublabel: 'per month' },
            { label: 'Pro Plan', value: 8, sublabel: 'one year' },
            { label: 'Pre Plan', value: 9, sublabel: 'one year' },
        ],
        isShakeStatus: false, // 按钮摇动
        isShowActMealStatus: window.location.pathname === '/dashboard' ? true : false, // 改版活动弹窗状态
        ActRversion: this.props.ActRversion, // 活动对象
        isHasActivityMeal: this.props.isHasActivityMeal, // 是否存在活动
        act_expired_time: this.props.act_expired_time,
        act_expired_mills_time: this.props.act_expired_mills_time,
        openActMealModal: this.props.openActMealModal, // 直接打开
        loadImgArr: [],
        trial_days: this.props.trial_days,
    }

    UNSAFE_componentWillMount() {
        let actStatus = null;
        try {
            actStatus = sessionStorage.getItem('actMealStatus') === null ? 1 : 0
        } catch (e) {
            actStatus = 0;
        }
        this.setState({
            isShowActMealStatus: Boolean(Number(actStatus)) && window.location.pathname === '/dashboard'
        })
    }

    componentDidMount() {
        // 存在则进行倒计时
        setTimeout(() => {
            if (Boolean(this.props.couponData) && Object.keys(this.props.couponData).length > 0) {
                //添加倒计时
                if (Boolean(this.props.couponData.app_coupon)) {
                    if (this.props.couponData.app_coupon.expires_in) {
                        this.appCountdown(this.props.couponData.app_coupon.expires_in);
                    }
                    if (this.props.couponData.zj_coupon.expires_in) {
                        this.zjCountdown(this.props.couponData.zj_coupon.expires_in);
                    }
                }
            }
        }, 0)

        this.shakeFreeBtn('none');
        this.reportActivityModalExposure();
    }

    componentDidUpdate() {
        this.reportActivityModalExposure();
    }

    // 摇动效果
    shakeFreeBtn = (type) => {
        if (type === 'none') {
            setTimeout(() => {
                this.setState({
                    isShakeStatus: false,
                }, () => {
                    this.shakeFreeBtn('show');
                })
            }, 1000)
        } else {
            setTimeout(() => {
                this.setState({
                    isShakeStatus: true,
                }, () => {
                    this.shakeFreeBtn('none');
                })
            }, 3000)
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.couponData !== this.state.couponData && Object.keys(nextProps.couponData).length > 0) {
            //通过数据判断弹窗是否显示
            let showIndexModal = false;
            let showNotice = false;
            if (Object.keys(nextProps.couponData.app_coupon).length > 0) {
                showNotice = true;
                showIndexModal = true;
            }
            if (Object.keys(nextProps.couponData.zj_coupon).length > 0) {
                showIndexModal = true;
            }

            //弹窗旨在首页显示
            // if (nextProps.showType !== 'index') {
            //     showIndexModal = false;
            // }

            this.setState({
                couponData: nextProps.couponData,
                showNotice: showNotice,
                showIndexModal: showIndexModal,
                appCouponData: nextProps.couponData.app_coupon,
                zjCouponData: nextProps.couponData.zj_coupon
            }, () => {
                //添加倒计时
                if (nextProps.couponData.app_coupon.expires_in) {
                    this.appCountdown(nextProps.couponData.app_coupon.expires_in);
                }
                if (nextProps.couponData.zj_coupon.expires_in) {
                    this.zjCountdown(nextProps.couponData.zj_coupon.expires_in);
                }
            })
        }

        // 活动弹窗状态
        if (nextProps.showBlackFridayModal !== this.props.showBlackFridayModal || nextProps.showBlackFridayBanner !== this.props.showBlackFridayBanner) {
            this.setState({
                isFreeUser: nextProps.level,
                showBlackFridayModal: nextProps.showBlackFridayModal,
                showBlackFridayBanner: nextProps.showBlackFridayBanner,
            })
        }

        if (nextProps.isHasActivity !== this.props.isHasActivity) {
            this.setState({
                activityMes: nextProps.activityMes,
                isHasActivity: nextProps.isHasActivity,
                actId: nextProps.actId,
                actName: nextProps.actName
            })
        }

        // 新手引导提示弹窗
        if (nextProps.isHideNewbieTipModal !== this.props.isHideNewbieTipModal) {
            if (nextProps.isHideNewbieTipModal !== null) {
                this.setState({
                    isShowNewbieTipModal: nextProps.isHideNewbieTipModal
                })
            }
        }

        if (nextProps.ActRversion !== this.props.ActRversion) {
            this.setState({
                ActRversion: nextProps.ActRversion
            })
        }

        if (nextProps.act_expired_mills_time !== this.props.act_expired_mills_time) {
            this.setState({
                act_expired_time: nextProps.act_expired_time,
                act_expired_mills_time: nextProps.act_expired_mills_time,
            })
        }

        if (nextProps.openActMealModal !== this.props.openActMealModal) {
            this.setState({
                openActMealModal: nextProps.openActMealModal
            })
        }

        if (nextProps.isHasActivityMeal !== this.props.isHasActivityMeal) {
            this.setState({
                isHasActivityMeal: nextProps.isHasActivityMeal
            })
        }

        if (nextProps.level !== this.props.level) {
            this.setState({
                level: nextProps.level
            })
        }

        if (nextProps.trial_days !== this.props.trial_days) {
            this.setState({
                trial_days: nextProps.trial_days
            })
        }


        return true;
    }

    componentWillUnmount = async () => {
        this.setState = () => false
    }

    //统计点击
    clickAppNoticeCount = async () => {
        const response = await reqClickAppNoticeCount();
        if (response) {
            utils.routeJump(this, "/plan", { c_notice: true })
        }

        return true;
    }

    // 时分秒倒计时
    appCountdown = async (end_time) => {
        var cacheTimera = setInterval(() => {
            let date1 = new Date(); //开始时间
            let date2 = end_time * 1000; //开始时间
            let date3 = date2 - date1 //时间差的毫秒数
            // console.log(date3, date2, date1)
            if (date3 < 0) {
                //倒计时结束隐藏
                clearInterval(cacheTimera);
                this.setState({ appCouponData: {}, showNotice: false })
            } else {
                //计算出小时数
                let leave1 = date3 % (72 * 3600 * 1000)  //计算天数后剩余的毫秒数
                let hours = Math.floor(leave1 / (3600 * 1000))
                //计算相差分钟数
                let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
                let minutes = Math.floor(leave2 / (60 * 1000))
                //计算相差秒数
                let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
                let seconds = Math.round(leave3 / 1000)

                let exp_time = "";
                if (hours < 24) {
                    exp_time += "";
                } else {
                    exp_time += `${Math.floor(date3 / (24 * 60 * 60 * 1000)) < 1 ? '' : `${Math.floor(date3 / (24 * 60 * 60 * 1000))}days `}`;
                }
                if (hours < 10) {
                    exp_time += "0" + hours + ":"
                } else {
                    exp_time += `${hours % 24}:`
                }
                if (minutes < 10) {
                    exp_time += "0" + minutes + ":"
                } else {
                    exp_time += minutes + ":"
                }
                if (seconds < 10) {
                    exp_time += "0" + seconds
                } else if (seconds === 60) {
                    exp_time += "00"
                } else {
                    exp_time += seconds
                }
                this.setState({ appExpiredTime: exp_time })
                if (date3 < 1000) {
                    setTimeout(() => {
                        clearInterval(cacheTimera);
                        this.setState({ appCouponData: {}, showNotice: false })
                    }, 1000)
                }
            }
        }, 1000)
    }

    zjCountdown = async (end_time) => {
        var cacheTimerb = setInterval(() => {
            let date1 = new Date(); //开始时间
            let date2 = end_time * 1000; //开始时间
            let date3 = date2 - date1 //时间差的毫秒数
            if (date3 < 0) {
                //倒计时结束隐藏
                clearInterval(cacheTimerb);
                this.setState({
                    zjCouponData: {},
                    showIndexModal: false
                })
            } else {
                //计算出小时数
                let leave1 = date3 % (72 * 3600 * 1000)  //计算天数后剩余的毫秒数
                let hours = Math.floor(leave1 / (3600 * 1000))
                //计算相差分钟数
                let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
                let minutes = Math.floor(leave2 / (60 * 1000))
                //计算相差秒数
                let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
                let seconds = Math.round(leave3 / 1000)

                let exp_time = "";

                if (hours < 10) {
                    exp_time += "0" + hours + ":"
                } else {
                    exp_time += hours + ":"
                }
                if (minutes < 10) {
                    exp_time += "0" + minutes + ":"
                } else {
                    exp_time += minutes + ":"
                }
                if (seconds < 10) {
                    exp_time += "0" + seconds
                } else if (seconds === 60) {
                    exp_time += "00"
                } else {
                    exp_time += seconds
                }
                this.setState({ zjExpiredTime: exp_time })
                if (date3 < 1000) {
                    setTimeout(() => {
                        clearInterval(cacheTimerb);
                        this.setState({
                            zjCouponData: {},
                            showIndexModal: false
                        })
                    }, 1000)
                }
            }
        }, 1000)
    }

    // 跳转活动详情页
    jumpViewDetails = (isJump, types, isAddLog = true) => {
        // 事件埋点
        if (isAddLog) {
            let params = { from: 1, action: 1, event: this.state.actName };
            reqAddActionEventLog(params);
        }
        reqSetShowModalStatus({ middle_status: 1, top_status: types === 'banner' ? 1 : 0 });
        this.setState({
            showBlackFridayModal: 1,
            showBlackFridayBanner: types === 'banner' ? 1 : 0,
        }, () => {
            this.props.closeBigSaleModalStatus(1, types);
            if (isJump) {
                utils.routeJump(this, '/admin/app-activity/index', { actId: this.state.actId, actName: this.state.actName }, { email_jump: 'app_jump' })
            }
        })
    }

    // 关闭活动banner
    closeBigSaleBanner = () => {
        this.jumpViewDetails(false, 'banner', false);
        this.props.closeBigSaleModalStatus(1, 'banner');
    }

    // 关闭活动弹窗广告
    closeBigSaleModal = () => {
        this.jumpViewDetails(false, 'modal', false);
        this.props.closeBigSaleModalStatus(1, 'modal');
    }

    // 隐藏图片预览
    hideImageDetailModal = () => {
        this.setState({
            imageDetailStatus: false,
            imageShowList: [],
            selImg: '',
        })
    }

    // 关闭改版活动弹窗
    closeActMealModal = () => {
        this.props.changeActMealModal(0);
        try {
            sessionStorage.setItem('actMealStatus', 0);
        } catch (e) { }
        this.setState({
            isShowActMealStatus: false,
        })
    }

    // 跳转价格页
    jumpPricing = () => {
        try {
            sessionStorage.setItem('actMealStatus', 0);
        } catch (e) { }
        utils.routeJump(this, "/plan")
    }

    // 图片加载
    imgLoadStatus = (url) => {
        this.setState({
            loadImgArr: [url]
        })
    }

    isActivityModalOpen = () => {
        const {
            isShowActMealStatus,
            isHasActivityMeal,
            openActMealModal,
        } = this.state;

        return Boolean((isShowActMealStatus && isHasActivityMeal) || openActMealModal);
    }

    reportActivityModalExposure = () => {
        const isOpen = this.isActivityModalOpen();
        if (!isOpen) {
            this.activityModalWasOpen = getNextActivityModalExposureLatch(isOpen, this.activityModalWasOpen, false);
            return;
        }
        if (!shouldReportActivityModalExposure(this.activityModalWasOpen, isOpen)) {
            return;
        }
        let didReport = false;
        try {
            const pricingPlan = store.getState().page?.pageInit?.pricingPlan;
            const reportData = buildActivityModalExposureData(pricingPlan, computeBestDiscount);
            if (reportData && this.props.cwreportCustomBehavior) {
                this.props.cwreportCustomBehavior('guide_entry_exposure', reportData);
                didReport = true;
            }
        } catch (error) {
            console.log('error:', error);
        }
        this.activityModalWasOpen = getNextActivityModalExposureLatch(isOpen, this.activityModalWasOpen, didReport);
    }

    render() {
        const {
            state: {
                imageDetailStatus,
                imageShowList,
                selImg,
                isShowActMealStatus,
                ActRversion,
                isHasActivityMeal,
                act_expired_time,
                openActMealModal,
                loadImgArr,
            },
            hideImageDetailModal,
            closeActMealModal,
            imgLoadStatus

        } = this;

        // 图片预览组件
        const imageShowModal = imageDetailStatus ? <ImageShowDetail
            selImg={selImg}
            hideImageDetailModal={hideImageDetailModal}
            imageShowList={imageShowList}
        /> : null;

        // 改版活动弹窗
        const ActivityModalShopify = <Modal
            open={(isShowActMealStatus && isHasActivityMeal) || openActMealModal}
            title={null}     
            onClose={closeActMealModal}
            noScroll={true}
        >
            <div className="shopify_modal_act">
                <div className={`black-modal isShowBlackModal`}>
                    <div className="black-content" style={{ height: !loadImgArr.includes(ActRversion.app_img) ? '270px' : '' }}>
                        {
                            typeof act_expired_time === 'string' ?
                                <div className="count-down-modal">
                                    <span>{act_expired_time.split(':')[0]} {t("Hours")} : {act_expired_time.split(':')[1]} {t("Mins")} : {act_expired_time.split(':')[2]} {t("Secs")}</span>
                                </div> : null
                        }
                        <img onClick={this.jumpPricing} onLoad={() => imgLoadStatus(ActRversion.app_img)} className='adver_modal_img' src={ActRversion.app_img} alt='adver_modal_img' />
                        {!loadImgArr.includes(ActRversion.app_img) ? <div className='load_img'>
                            <img src='/imgs/Image/load_img.png' alt='' />
                        </div> : null}
                    </div>
                </div>
            </div>
        </Modal>

        return this.state.loadingPage ? (
            <div>
                {imageShowModal}
                {ActivityModalShopify}
            </div>
        ) : null;
    }
}

export default withRouter(EventInformation);